<template>
  <v-layout>
    <v-tooltip top v-for="(item, index) in interesteds" :key="item.id">
      <v-avatar
        class="mr-1"
        size="32"
        slot="activator"
        v-if="!!item.avatar && index <= 6"
      >
        <v-img :src="item.avatar" :alt="item.name" />
      </v-avatar>
      <v-avatar
        class="mr-1"
        color="grey lighten-2"
        size="32"
        slot="activator"
        v-else-if="!!item.avatar === false && index <= 6"
      >
        <span>{{ acronym(item.name) }}</span>
      </v-avatar>
      <span>{{ item.name }} ({{ interestedType(item) }})</span>
    </v-tooltip>
    <v-avatar
      class="mr-1"
      size="32"
      v-if="interesteds.length > 7"
    >
      <strong class="grey--text text--darken-2">
        + {{ interesteds.length - 7 }}
      </strong>
    </v-avatar>
  </v-layout>
</template>

<script>
import acronym from '@/utils/acronym';

export default {
  name: 'InterestedsAvatarList',
  data() {
    return {
      acronym,
    };
  },
  props: ['interesteds'],
  methods: {
    interestedType({type}){
      const types = {'User': 'Colaborador', 'Citizen': 'Cliente'}
      return types[type];
    },
  },
};
</script>

<style scoped lang="scss">
  .v-image{
    background: #e0e0e0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/interested/list/InterestedAvatarList.vue